export default __webpack_public_path__ + "static/media/partly_cloudy_day.bd85c6fe.svg";